/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCustomerLiterStatisticsAsync, ICustomerLiterStatistics } from './get-customer-liter-statistics';

/**
 * GetCustomerLiterStatistics Input Action
 */
export class GetCustomerLiterStatisticsInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `get-customer-liter-statistics`;
    public getCacheObjectType = () => 'CustomerLiterStatistics';
    public dataCacheType = (): Msdyn365.CacheType => 'none'; // Change to 'request'
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCustomerLiterStatisticsInput();
};

async function action(input: GetCustomerLiterStatisticsInput, ctx: Msdyn365.IActionContext): Promise<ICustomerLiterStatistics[]> {
    if (!ctx.requestContext.user.isAuthenticated) {
        return [];
    }

    if (ctx.requestContext.query?.fakeData === 'true') {
        return [
            {
                RecId: 0,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 1",
                Year: 2019,
                InvoiceAmount: 1555,
                Volume: 449,
                VolumeUnit: "ltr"
            },
            {
                RecId: 1,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 2",
                Year: 2019,
                InvoiceAmount: 1190,
                Volume: 141,
                VolumeUnit: "cl"
            },
            {
                RecId: 2,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 3",
                Year: 2019,
                InvoiceAmount: 1992,
                Volume: 370,
                VolumeUnit: "ltr"
            },
            {
                RecId: 3,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 1",
                Year: 2020,
                InvoiceAmount: 1217,
                Volume: 478,
                VolumeUnit: "ltr"
            },
            {
                RecId: 4,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 2",
                Year: 2020,
                InvoiceAmount: 1997,
                Volume: 293,
                VolumeUnit: "cl"
            },
            {
                RecId: 5,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 3",
                Year: 2020,
                InvoiceAmount: 1012,
                Volume: 455,
                VolumeUnit: "ltr"
            },
            {
                RecId: 6,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 1",
                Year: 2021,
                InvoiceAmount: 1846,
                Volume: 89,
                VolumeUnit: "cl"
            },
            {
                RecId: 7,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 2",
                Year: 2021,
                InvoiceAmount: 1948,
                Volume: 288,
                VolumeUnit: "cl"
            },
            {
                RecId: 8,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 3",
                Year: 2021,
                InvoiceAmount: 1041,
                Volume: 142,
                VolumeUnit: "ltr"
            },
            {
                RecId: 9,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 1",
                Year: 2022,
                InvoiceAmount: 578,
                Volume: 244,
                VolumeUnit: "ltr"
            },
            {
                RecId: 10,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 2",
                Year: 2022,
                InvoiceAmount: 1175,
                Volume: 96,
                VolumeUnit: "ltr"
            },
            {
                RecId: 11,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 3",
                Year: 2022,
                InvoiceAmount: 1020,
                Volume: 494,
                VolumeUnit: "ltr"
            },
            {
                RecId: 12,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 1",
                Year: 2023,
                InvoiceAmount: 1450,
                Volume: 417,
                VolumeUnit: "ltr"
            },
            {
                RecId: 13,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 2",
                Year: 2023,
                InvoiceAmount: 1989,
                Volume: 165,
                VolumeUnit: "ltr"
            },
            {
                RecId: 14,
                InvoiceAccount: "12345",
                ItemGroupDisplayOrderName: "Kategori 3",
                Year: 2023,
                InvoiceAmount: 1873,
                Volume: 490,
                VolumeUnit: "ltr"
            }
        ];
    }

    return getCustomerLiterStatisticsAsync({ callerContext: ctx });
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICustomerLiterStatistics[]>>action,
    id: 'vinhuset/get-customer-liter-statistics',
    input: createInput
});
